module.exports = "/assets/logo_sg_animate-73355ee4247a6c34fdd9a8af12eec97e.png";